<template>
	<div class="cw-host">
		<div class="cw-overlay" @click.self="$emit('pop')">
			<div class="cw-window">
				<div class="cw-header">
					<div class="cw-header__id">
						<div class="cw-header__name">{{ name }}</div>
						<div class="cw-header__sub">{{ sub }}</div>
					</div>
					<div class="cw-header__close" @click="$emit('pop')">✕</div>
				</div>

				<div class="cw-body">
					<div class="cw-rail">
						<div
							v-for="t in tabs"
							:key="t.name"
							class="cw-rail__tab"
							:class="{ 'is-active': active === t.name }"
							@click="active = t.name"
						>{{ t.label }}</div>
					</div>
					<div class="cw-pane">
						<customer-content :cw="cw" :activity="cwActivity" :active="active" theme="dark" @open="cwOpen" />
					</div>
				</div>

				<div class="cw-footer">
					<div class="cw-footer__btn" @click="openPage">Åbn som side</div>
					<div class="cw-footer__btn cw-footer__btn--primary" @click="edit">Rediger</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import customerData from './customerData'
	import CustomerContent from './CustomerContent'
	import ContactWindow from '../windows/ContactWindow'

	export default {
		name: 'customer-window',
		pos: 'center',
		mixins: [customerData],
		components: { CustomerContent },
		props: {
			value: { type: Object, required: true },
			submit: { type: Function, default: function () { return true; } }
		},
		data() {
			return {
				active: 'overview',
				tabs: [
					{ name: 'overview', label: 'Oversigt' },
					{ name: 'orders', label: 'Ordrer' },
					{ name: 'quotes', label: 'Tilbud' },
					{ name: 'tasks', label: 'Opgaver' },
					{ name: 'packaging', label: 'Emballage' },
					{ name: 'activity', label: 'Aktivitet' }
				]
			};
		},
		computed: {
			name() { return (this.cw.contact && this.cw.contact.name) || this.value.name || 'Kunde'; },
			sub() { const c = this.cw.contact || this.value; return [c.zip, c.city].filter(Boolean).join(' '); }
		},
		methods: {
			edit() {
				this.$emit('push', ContactWindow, { value: this.cw.contact || this.value, submit: this.submit });
			},
			openPage() {
				const id = (this.cw.contact || this.value).id;
				this.$emit('close');
				this.$router.push({ name: 'customer-detail', params: { lang: this.$route.params.lang || 'da', id: id } });
			}
		},
		mounted() {
			this.cw.contact = this.value;
			this.cwLoad(this.value.id);
		}
	};
</script>

<style lang="scss" scoped>
	.cw-overlay {
		position: fixed;
		left: 0; top: 0; right: 0; bottom: 0;
		background: rgba(0, 0, 0, 0.55);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 50;
	}

	.cw-window {
		width: 1080px;
		max-width: 94vw;
		height: 760px;
		max-height: 92vh;
		background: #15161a;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		font-family: 'Montserrat', sans-serif;
	}

	.cw-header {
		flex: none;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 70px;
		padding: 0 30px;
		background: #202127;
		border-bottom: 1px solid #2d2f36;
	}
	.cw-header__name { color: #fff; font-size: 16px; font-weight: 700; }
	.cw-header__sub { color: #a0a3ac; font-size: 11px; margin-top: 2px; }
	.cw-header__close { color: #a0a3ac; font-size: 16px; cursor: pointer; }
	.cw-header__close:hover { color: #fff; }

	.cw-body { flex: 1 1 auto; min-height: 0; display: grid; grid-template-columns: 230px 1fr; }
	.cw-rail { background: #202127; border-right: 1px solid #2d2f36; overflow-y: auto; padding: 16px 0; }
	.cw-rail__tab {
		color: #a0a3ac;
		font-size: 13px;
		padding: 10px 30px;
		cursor: pointer;
		border-left: 2px solid transparent;
	}
	.cw-rail__tab:hover { color: #fff; }
	.cw-rail__tab.is-active { color: #fff; border-left-color: #f7223f; background: #15161a; }
	.cw-pane { overflow-y: auto; min-width: 0; }

	.cw-footer {
		flex: none;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 10px;
		height: 70px;
		padding: 0 30px;
		background: #202127;
		border-top: 1px solid #2d2f36;
	}
	.cw-footer__btn {
		font-size: 13px;
		color: #fff;
		border: 1px solid #2d2f36;
		border-radius: 20px;
		padding: 10px 24px;
		cursor: pointer;
	}
	.cw-footer__btn:hover { border-color: #f7223f; }
	.cw-footer__btn--primary { background: #f7223f; border-color: #f7223f; }
</style>
